import { useUser } from "@dashboard/auth";
import { hasPermissions } from "@dashboard/components/RequirePermissions";
import { PermissionEnum } from "@dashboard/graphql";

export const useHasManageOrdersPermission = () => {
  const user = useUser();

  return hasPermissions(user?.user?.userPermissions ?? [], [PermissionEnum.MANAGE_ORDERS]);
};
